const Config = {
  apiUrl: 'https://jci.nmma.co/wp/wp-json',
};

export default Config;
